import "./App.css";
import AllPages from "../src/Pages/AllPages";
import Navbar from "./Components/Navbar/Navbar";
function App() {
  return (
    <div>
      <Navbar />
      <AllPages />
    </div>
  );
}

export default App;
